import App from './src/App';
import clientApolloSchema from './src/clientState';

export { App as default, clientApolloSchema };
